module.exports = __webpack_public_path__ + "images/btn-play-83f8af2aa03ae79bc7b40cddcd845c20.png";